import React from "react";

const PromptDarkAlt = () => {
  return (
    <svg
      width="140"
      height="150"
      viewBox="0 0 140 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.84002 100.704C2.6295 98.0096 2.21073 93.223 4.90467 90.0125L70.7552 11.5349C73.4492 8.32435 78.2357 7.90559 81.4462 10.5995L133.474 54.256C136.684 56.95 137.103 61.7365 134.409 64.947L68.5588 143.425C65.8648 146.635 61.0783 147.054 57.8678 144.36L5.84002 100.704Z"
        fill="#1C1C1C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.5948 27.8186C14.0626 11.0521 28.8445 -1.3499 45.611 0.117955L46.6169 0.206016C62.955 1.63636 74.9835 16.1279 73.3806 32.45L73.1931 34.3589C72.9863 36.465 71.1113 38.0047 69.0052 37.7978C66.899 37.591 65.3593 35.716 65.5662 33.6098L65.7536 31.701C66.9398 19.6226 58.0387 8.89891 45.9485 7.84046L44.9426 7.75239C32.3925 6.65367 21.3279 15.9369 20.2292 28.487L20.1001 29.9623C19.9155 32.0705 18.0569 33.6299 15.9487 33.4454C13.8405 33.2608 12.2811 31.4022 12.4656 29.294L12.5948 27.8186ZM14.4751 50.2772C16.5833 50.4617 18.1427 52.3204 17.9581 54.4286L17.366 61.192C15.8011 79.0678 29.0237 94.8277 46.8995 96.3926C64.7655 97.9567 80.5407 84.6729 82.1065 66.7871C82.4656 62.6861 86.0815 59.6272 90.2024 59.988L94.4973 60.364C96.6055 60.5486 98.1649 62.4072 97.9803 64.5154C97.7957 66.6236 95.9371 68.183 93.8289 67.9984L89.7245 67.6391C87.6997 89.6288 68.2719 105.957 46.2311 104.027C24.1389 102.093 7.7975 82.6158 9.73159 60.5236L10.3237 53.7602C10.5083 51.652 12.3669 50.0926 14.4751 50.2772ZM67.3653 54.4959C69.4714 54.7027 71.0111 56.5778 70.8043 58.6839L70.0779 66.0804C68.9993 77.0632 59.2939 85.1438 48.3355 84.3833C37.1046 83.6039 28.5588 73.7595 29.5454 62.4905L29.89 58.5543C30.0745 56.4461 31.9332 54.8867 34.0414 55.0713C36.1496 55.2559 37.709 57.1145 37.5244 59.2227L37.1798 63.1589C36.5718 70.1037 41.8573 76.2517 48.8661 76.7381C55.7381 77.215 61.7827 72.1364 62.451 65.3314L63.1773 57.9349C63.3842 55.8288 65.2592 54.2891 67.3653 54.4959Z"
        fill="#E1E1E1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M69.1218 38.7623C64.878 38.3908 61.1873 41.5137 60.8232 45.672C60.4592 49.8303 63.5512 53.547 67.7949 53.9185C72.0387 54.29 75.7295 51.1672 76.0935 47.0089C76.4575 42.8505 73.3655 39.1339 69.1218 38.7623ZM53.1888 45.0036C53.9243 36.602 61.357 30.3896 69.7902 31.1279C78.2233 31.8662 84.4635 39.2756 83.7279 47.6772C82.9924 56.0789 75.5597 62.2912 67.1266 61.5529C58.6934 60.8146 52.4532 53.4053 53.1888 45.0036Z"
        fill="#E1E1E1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.0212 34.1146C11.7775 33.7431 8.08667 36.866 7.72262 41.0243C7.35858 45.1826 10.4506 48.8993 14.6943 49.2708C18.9381 49.6423 22.6289 46.5195 22.9929 42.3611C23.357 38.2028 20.265 34.4862 16.0212 34.1146ZM0.0881847 40.3559C0.823718 31.9543 8.25641 25.7419 16.6896 26.4802C25.1227 27.2185 31.3629 34.6279 30.6274 43.0295C29.8918 51.4312 22.4591 57.6435 14.026 56.9052C5.59281 56.1669 -0.647349 48.7576 0.0881847 40.3559Z"
        fill="#E1E1E1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.9546 16.442C11.4773 12.1765 19.7831 13.9424 27.2517 15.9501C29.2954 16.4995 30.5067 18.6017 29.9573 20.6454C29.4079 22.6891 27.3058 23.9004 25.2621 23.351C17.858 21.3606 12.1148 20.4274 6.38454 23.2953C4.49207 24.2424 2.1901 23.4761 1.24295 21.5836C0.295801 19.6912 1.06213 17.3892 2.9546 16.442Z"
        fill="#E1E1E1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M80.5002 29.7834C75.3555 25.9635 69.5375 25.8845 61.9002 26.5581C59.7921 26.7441 57.9324 25.1859 57.7465 23.0778C57.5606 20.9697 59.1188 19.1101 61.2268 18.9241C68.9307 18.2447 77.4169 17.9489 85.0688 23.6304C86.7679 24.892 87.1226 27.2921 85.861 28.9912C84.5995 30.6903 82.1993 31.045 80.5002 29.7834Z"
        fill="#E1E1E1"
      />
    </svg>
  );
};

export default PromptDarkAlt;
